import { render, staticRenderFns } from "./CoozzyYoutubeIcon.vue?vue&type=template&id=4b3ef695&scoped=true"
import script from "./CoozzyYoutubeIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyYoutubeIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyYoutubeIcon.vue?vue&type=style&index=0&id=4b3ef695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ef695",
  null
  
)

export default component.exports